import { DriverLicenseCategoryData } from '@/common/types/driverLicenseCategory'

export const transformNewDriverLicenseCategories = (licenseCategory: { value?: string }) => ({
  license_category_id: licenseCategory.value,
})

export const transformDriverLicenseCategoriesToOptions = (
  driverLicenseCategories: { id: string; license_category: DriverLicenseCategoryData }[],
) =>
  driverLicenseCategories.map(({ license_category }) => ({
    label: license_category.display_name,
    value: license_category.id,
  }))
